<template>
  <div
    class="opple-relate-config"
  >
    <div class="border_title">
      {{ $t('ifttt.associatedConfiguration') }}
    </div>
    <div class="opple-relate-container">
      <div
        class="opple-config-navBar"
      >
        <div
          class="opple-config-navBar_item"
          :class="{active: currentTab === 0}"
          @click="() => onItemClick(0)"
        >
          {{ $t('ifttt.associatedConfiguration') }}
        </div>
        <p>{{ $t('ifttt.associatedInfo') }}</p>
        <img :src="$img('elfNotice2')">
      </div>
      <Platform
        ref="Platform"
        :device="device"
      />
    </div>
  </div>
</template>

<script>
import NavBar from './components/NavBar.vue';
import Platform from './components/Platform.vue';

export default {
  name: 'OppleRelateConfig',
  components: {
    NavBar,
    Platform
  },
  props: ['device'],
  data() {
    return {
      currentTab: 0
    };
  },

  computed: {

  },

  watch: {
    item(value) {
      this.setCom();
    }
  },

  mounted() {

  },

  methods: {
    onItemClick(tab) {
      this.currentTab = tab;
    },

    init() {
      this.$refs.Platform.init();
    }
  },
};
</script>

<style lang="scss">
.opple-relate-config {
  .border_title {
    position: relative;
    text-indent: 10px;
    font-size: 16px;
    color: #111;
    
    &::after {
      width: 2px;
      background-color: #0046aa;
      bottom: 0;
      content: "";
      position: absolute;
      left: 0;
      height: 16px;
    }
  }
  .opple-relate-container {
    display: flex;
    width: 100%;
    padding: 32px 0;
    justify-content: space-between;
    border: 1px solid #eee;
  }
  .opple-config-navBar {
    p {
      padding: 9px;
      font-size: 14px;
      color: #9E9E9E;
    }

    img {
      width: 100%;
    }
  }
}

</style>